module.exports = __webpack_public_path__ + "img/dex-imaging.d066cf8d.png";